var _path, _path2, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingcart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1216 12.2833H6.12247C6.12319 12.2833 6.12392 12.2832 6.12464 12.2832H16.2168C16.4653 12.2832 16.6837 12.1184 16.752 11.8795L18.9785 4.08652C19.0265 3.91852 18.9929 3.7379 18.8878 3.59845C18.7826 3.459 18.618 3.37695 18.4434 3.37695H4.83784L4.43993 1.58628C4.38326 1.33159 4.15741 1.15039 3.89648 1.15039H0.556641C0.249184 1.15039 0 1.39957 0 1.70703C0 2.01449 0.249184 2.26367 0.556641 2.26367H3.45001C3.52046 2.58099 5.35419 10.8329 5.45972 11.3076C4.86814 11.5648 4.45312 12.1546 4.45312 12.8398C4.45312 13.7606 5.20227 14.5098 6.12305 14.5098H16.2168C16.5243 14.5098 16.7734 14.2606 16.7734 13.9531C16.7734 13.6457 16.5243 13.3965 16.2168 13.3965H6.12305C5.81617 13.3965 5.56641 13.1467 5.56641 12.8398C5.56641 12.5334 5.8153 12.2841 6.1216 12.2833ZM17.7054 4.49023L15.7969 11.1699H6.56952L5.08514 4.49023H17.7054Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56641 16.1797C5.56641 17.1005 6.31555 17.8496 7.23633 17.8496C8.1571 17.8496 8.90625 17.1005 8.90625 16.1797C8.90625 15.2589 8.1571 14.5098 7.23633 14.5098C6.31555 14.5098 5.56641 15.2589 5.56641 16.1797ZM7.23633 15.623C7.54321 15.623 7.79297 15.8728 7.79297 16.1797C7.79297 16.4866 7.54321 16.7363 7.23633 16.7363C6.92945 16.7363 6.67969 16.4866 6.67969 16.1797C6.67969 15.8728 6.92945 15.623 7.23633 15.623Z",
    fill: "#7E7E7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4336 16.1797C13.4336 17.1005 14.1827 17.8496 15.1035 17.8496C16.0243 17.8496 16.7734 17.1005 16.7734 16.1797C16.7734 15.2589 16.0243 14.5098 15.1035 14.5098C14.1827 14.5098 13.4336 15.2589 13.4336 16.1797ZM15.1035 15.623C15.4104 15.623 15.6602 15.8728 15.6602 16.1797C15.6602 16.4866 15.4104 16.7363 15.1035 16.7363C14.7966 16.7363 14.5469 16.4866 14.5469 16.1797C14.5469 15.8728 14.7966 15.623 15.1035 15.623Z",
    fill: "#7E7E7E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6,
    width: 1,
    height: 4,
    rx: 0.5,
    fill: "#D61D4F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7.5,
    width: 1,
    height: 4,
    rx: 0.5,
    transform: "rotate(90 13 7.5)",
    fill: "#D61D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcart);
export default __webpack_public_path__ + "static/media/shoppingcart.83b7f729e7c47a99580647a9a01bf30b.svg";
export { ForwardRef as ReactComponent };